import { twMerge } from "tailwind-merge";

export default function ToolsPageSectionLabel({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className="flex items-center gap-[10px] mb-[11px]">
      <div
        className={twMerge(
          "text-[#8fa0b0] text-[11px] font-bold uppercase",
          className
        )}
      >
        {children}
      </div>
      <div className="flex-1 h-[1px] bg-[#8fa0b0]/50"></div>
    </div>
  );
}
